/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './tx-simple-map.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/shared/component/tx-simple-map/tx-simple-map.component';
const styles_TxSimpleMapComponent:any[] = [i0.styles];
export const RenderType_TxSimpleMapComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TxSimpleMapComponent,data:{}});
export function View_TxSimpleMapComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'div',[['style',
      'height: 100%; width: 100%']],[[8,'id',0]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(null as any),(_ck,
      _v) => {
    var _co:i2.TxSimpleMapComponent = _v.component;
    const currVal_0:any = _co.mapId;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_TxSimpleMapComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'tx-simple-map',
      ([] as any[]),(null as any),(null as any),(null as any),View_TxSimpleMapComponent_0,
      RenderType_TxSimpleMapComponent)),i1.ɵdid(1,4308992,(null as any),0,i2.TxSimpleMapComponent,
      [i1.ElementRef],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TxSimpleMapComponentNgFactory:i1.ComponentFactory<i2.TxSimpleMapComponent> = i1.ɵccf('tx-simple-map',
    i2.TxSimpleMapComponent,View_TxSimpleMapComponent_Host_0,{mapId:'mapId',coordinate:'coordinate'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnQvdHgtc2ltcGxlLW1hcC90eC1zaW1wbGUtbWFwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2plbmtpbnMvd29ya3NwYWNlL3Byb2R1Y3Rpb24tYXJnb3MtZnJvbnQvYXJnb3Mvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50L3R4LXNpbXBsZS1tYXAvdHgtc2ltcGxlLW1hcC5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL2plbmtpbnMvd29ya3NwYWNlL3Byb2R1Y3Rpb24tYXJnb3MtZnJvbnQvYXJnb3Mvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50L3R4LXNpbXBsZS1tYXAvdHgtc2ltcGxlLW1hcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnQvdHgtc2ltcGxlLW1hcC90eC1zaW1wbGUtbWFwLmNvbXBvbmVudC50cy5UeFNpbXBsZU1hcENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgW2lkXT1cIm1hcElkXCIgc3R5bGU9XCJoZWlnaHQ6IDEwMCU7IHdpZHRoOiAxMDAlXCI+PC9kaXY+XG4iLCI8dHgtc2ltcGxlLW1hcD48L3R4LXNpbXBsZS1tYXA+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBQSxnQkFBMEQ7OztJQUFyRDtJQUFMLFdBQUssU0FBTDs7OztvQkNBQTtNQUFBO3FDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/shared/component/tx-simple-map/tx-simple-map.component.ngfactory.ts